<template>
    <transition name="fade-in">
        <div class="register" @keydown.enter="handleSubmit">
            <div class="register-con">
                <Card icon="log-in" title="登録" :bordered="false">
                    <div class="form-con">
                        <Form ref="registerForm" :model="form" :rules="rules">
                            <FormItem prop="loginName">
                                <Input v-model.trim="form.loginName" :maxlength="64" :placeholder="t.user.loginName">
                              <span slot="prepend">
                                <Icon type="md-person" :size="16"/>
                              </span>
                                </Input>
                            </FormItem>
                            <FormItem prop="password">
                                <Input type="password" v-model.trim="form.password" :maxlength="25"
                                       :placeholder="t.user.password">
                              <span slot="prepend">
                                <Icon type="md-lock" :size="16"/>
                              </span>
                                </Input>
                            </FormItem>
                            <FormItem prop="name">
                                <Input v-model.trim="form.name" :maxlength="32" :placeholder="t.user.name">
                              <span slot="prepend">
                                <Icon type="md-happy" :size="16"/>
                              </span>
                                </Input>
                            </FormItem>
                            <FormItem prop="email">
                                <Input v-model.trim="form.email" :maxlength="100" :placeholder="t.user.email">
                              <span slot="prepend">
                                <Icon type="md-mail" :size="16"/>
                              </span>
                                </Input>
                            </FormItem>
                            <FormItem prop="mobile">
                                <Input v-model.trim="form.mobile" :maxlength="15" :placeholder="t.user.mobile">
                              <span slot="prepend">
                                <Icon type="md-phone-portrait" :size="16"/>
                              </span>
                                </Input>
                            </FormItem>
                            <FormItem>
                                <RadioGroup v-model.trim="form.sex" type="button" size="small">
                                    <Radio label="0">{{t.user.male}}</Radio>
                                    <Radio label="1">{{t.user.female}}</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem prop="captcha">
                                <Row>
                                    <Col span="15">
                                        <Input v-model.trim="form.captcha" :maxlength="4" :placeholder="t.user.captcha">
                                      <span slot="prepend">
                                        <Icon type="ios-images" :size="16"/>
                                      </span>
                                        </Input>
                                    </Col>
                                    <Col span="9" style="height:31px;">
                                        <transition name="fade" mode="out-in">
                                            <p class="countdown"
                                               v-if="totalTime>0">
                                                {{totalTime}}
                                            </p>
                                            <img :src="imgSrc" class="captcha"
                                                 @click="generateCaptcha" v-if="totalTime===0"/>
                                        </transition>
                                    </Col>
                                </Row>
                            </FormItem>
                            <div>
                                <Button @click="handleSubmit" type="primary" long>登録</Button>
                                <p style="font-size: 12px;text-align:left;margin-top:8px;">
                                    <router-link to="/login">
                                        ログイン
                                        <Icon type="md-return-left"/>
                                    </router-link>
                                </p>
                            </div>
                        </Form>
                    </div>
                    <Spin fix size="large" v-if="loading">
                        <slot name="loading"></slot>
                    </Spin>
                </Card>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions } from 'vuex';
import { captchaGet, captchaVerify, register } from '@/api/app';

export default {
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            t: t,
            msgUtil: msgUtil,
            form: {
                loginName: '',
                name: '',
                password: '',
                avatar: '',
                email: '',
                mobile: '',
                sex: '0',
                captcha: '',
            },
            imgSrc: '',
            captchaKey: '',
            totalTime: 0,
            loading: false,
            ruleValidate: {
                mobile: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.mobile),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]*$/,
                        message: msgUtil.errorRequiredHalfWidthNumber(t.user.mobile),
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.email),
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: msgUtil.errorFormat(t.user.email),
                        trigger: 'blur',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.user.loginName, 32),
                        trigger: 'blur',
                    },
                ],
                loginName: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.loginName),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9a-zA-Z]*$/,
                        message: msgUtil.errorRequiredHalfWidthCharOrNumber(t.user.loginName),
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.password),
                        trigger: 'blur',
                    },
                ],
                captcha: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.user.captcha),
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        rules() {
            return {
                mobile: this.mobileRules,
                email: this.emailRules,
                name: this.nameRules,
                loginName: this.loginNameRules,
                password: this.passwordRules,
                captcha: this.captchaRules,
            };
        },
    },
    methods: {
        ...mapActions('user', ['handleRegister']),
        async handleSubmit() {
            this.$refs.registerForm.validate(async valid => {
                this.loading = true;
                if (valid) {
                    try {
                        await register(this.form, this.captchaKey);
                        this.$Message.success({
                            content: '登録成功',
                            duration: 60,
                            closable: true,
                        });
                    } catch (error) {
                        //console.log(error);
                    }
                }
                this.loading = false;
            });
        },
        async init() {
            let captcha = await captchaGet();
            if (captcha.captcha_key == null || captcha.captcha_key == undefined) {
                this.runCountdown();
                return;
            }
            this.captchaKey = captcha.captcha_key;
            this.imgSrc = 'data:img/jpg;base64,' + captcha.image;
        },
        runCountdown() {
            this.totalTime = 60;
            let clock = window.setInterval(() => {
                this.totalTime--;
                if (this.totalTime <= 0) {
                    window.clearInterval(clock);
                }
            }, 1000);
        },
        generateCaptcha() {
            this.init();
        },
    },
    created() {
        this.init();
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.register {
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/login_bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    &-con {
        position: absolute;
        right: 160px;
        top: 50%;
        transform: translateY(-60%);
        width: 300px;
        &-header {
            font-size: 16px;
            font-weight: 300;
            text-align: center;
            padding: 30px 0;
        }
        .form-con {
            padding: 10px 0 0;
        }
    }
}

.countdown {
    width: 100px;
    height: 31px;
    background-color: #dcdee2;
    margin-top: 1px;
    margin-left: 1px;
    /*margin-bottom: 13px;*/
    font-size: 20px;
    font-weight: bold;
    color: #1f2d3d;
    text-align: center;
}

.captcha {
    margin: 1px;
    width: 100px;
    height: 31px;
    cursor: pointer;
}
</style>
